import {ExtraServiceType, ExtrasResourceDto} from '@lib/infrastructure';
import {Extra, LoadingStatus} from '../entities';

export type ExtrasState = {
  extras: Extra[];
  isLoading: boolean;

  extraServicesLoadingStatus: LoadingStatus;
  extraServicesByCategoryByBuilding: ExtraServicesByCategoryByBuildingIdType;
};

export enum ExtrasTypes {
  WORKDAY = 'Workday',
  USER_PROFILE = 'UserProfile',
  HYBRID_MEETINGS = 'HybridMeetings',
}

export type LocationType = 'MeetingRoom' | 'Area' | 'Facility';
export type ExtraService = {
  id: string;
  title: string;
  description?: string;
  serviceType: ExtraServiceType;
  resource: ExtrasResourceDto;
  buildingId: string;
} & (
  | {
      category: 'General' | 'WorkdayBased' | 'EventBased';
    }
  | {
      category: 'LocationBased';
      locationTypes: LocationType[];
    }
);

export type ExtraServicesForBuildingType = {
  buildingId: string;
  buildingName: string;
  data: ExtraService[];
};
export type ExtraServicesByBuildingIdType = Record<string, ExtraServicesForBuildingType | undefined>;
export type ExtraServicesByCategoryByBuildingIdType = Record<ExtraService['category'], ExtraServicesByBuildingIdType>;
